<template>
  <div>
    <div class="mb-8">
      <p
        class="text-center text-wedding-blue text-xl tracking-widest mb-2"
        style="font-family: DM_Sans_bold"
      >
        {{ groomName }} & {{ brideName }}
      </p>

      <div class="text-center text-wedding-black px-4">
        <p>มีความยินดีขอเรียนเชิญเพื่อเป็นเกียรติ </p>
        <p>เนื่องในพิธีมงคลสมรส</p>
      </div>
    </div>

    <div class="flex-col">
      <card-detail-info
        v-if="eventInfo.mode == 'morning' || eventInfo.mode == 'morningAndEvening'"
        :title="'งานเช้า'"
        :information="eventInfo.morning"
      />

      <card-detail-info
        v-if="eventInfo.mode == 'evening' || eventInfo.mode == 'morningAndEvening'"
        :title="'งานเย็น'"
        :information="eventInfo.evening"
      />

      <div class="w-full my-10 text-center">
          <!-- @click="showImageCard" -->
        <button 
          @click="showViewer"
          class="h-10 px-5 w-40 text-wedding-blue transition-colors duration-150 border border-gray rounded-full focus:shadow-outline"
          style="font-family: Anuphan_medium; "
        >
          <div class="flex justify-center items-center">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 7.99999V7.24999H1.25V7.99999H2ZM16 7.99999H16.75V7.24999H16V7.99999ZM16 18V18.75C16.4142 18.75 16.75 18.4142 16.75 18H16ZM2 18H1.25C1.25 18.4142 1.58579 18.75 2 18.75V18ZM1 4.99999V4.24999C0.585786 4.24999 0.25 4.58578 0.25 4.99999H1ZM17 4.99999H17.75C17.75 4.58578 17.4142 4.24999 17 4.24999V4.99999ZM17 7.99999V8.74999C17.4142 8.74999 17.75 8.41421 17.75 7.99999H17ZM1 7.99999H0.25C0.25 8.41421 0.585786 8.74999 1 8.74999L1 7.99999ZM8.86591 4.84997L8.14147 4.65582L7.94732 5.38026L8.67176 5.57441L8.86591 4.84997ZM14.0621 1.84997L14.7116 1.47497L14.0621 1.84997ZM9.06232 4.84997L9.25647 5.57441L9.9809 5.38026L9.78675 4.65582L9.06232 4.84997ZM3.86617 1.84997L3.21665 1.47497L3.86617 1.84997ZM2 8.74999H16V7.24999H2V8.74999ZM15.25 7.99999V18H16.75V7.99999H15.25ZM16 17.25H2V18.75H16V17.25ZM2.75 18V7.99999H1.25V18H2.75ZM1 5.74999H17V4.24999H1V5.74999ZM16.25 4.99999V7.99999H17.75V4.99999H16.25ZM17 7.24999H1V8.74999H17V7.24999ZM1.75 7.99999V4.99999H0.25V7.99999H1.75ZM9.59034 5.04412C9.81892 4.19124 10.6426 2.92567 11.5705 2.19729C12.0346 1.83294 12.4228 1.68419 12.6937 1.68451C12.8907 1.68474 13.1444 1.76048 13.4125 2.22497L14.7116 1.47497C14.2297 0.640392 13.5275 0.185492 12.6954 0.184511C11.9372 0.183617 11.223 0.563077 10.6443 1.01739C9.4864 1.92631 8.46201 3.45979 8.14147 4.65582L9.59034 5.04412ZM13.4125 2.22497C13.6807 2.6895 13.6195 2.94712 13.5212 3.11788C13.386 3.35264 13.0631 3.61443 12.5156 3.83422C11.4208 4.27363 9.913 4.35413 9.06006 4.12554L8.67176 5.57441C9.86792 5.89498 11.7082 5.7746 13.0743 5.22627C13.7571 4.9522 14.4428 4.52341 14.8211 3.86628C15.2363 3.14515 15.1934 2.30956 14.7116 1.47497L13.4125 2.22497ZM9.78675 4.65582C9.46621 3.45979 8.44182 1.92631 7.28393 1.01739C6.70518 0.563077 5.99101 0.183617 5.23278 0.184511C4.40069 0.185492 3.69849 0.640392 3.21665 1.47497L4.51569 2.22497C4.78386 1.76048 5.03754 1.68474 5.23455 1.68451C5.50543 1.68419 5.89359 1.83294 6.35773 2.19729C7.28564 2.92567 8.10931 4.19124 8.33788 5.04412L9.78675 4.65582ZM3.21665 1.47497C2.7348 2.30956 2.69191 3.14515 3.10708 3.86628C3.48539 4.52341 4.17109 4.9522 4.85392 5.22627C6.22001 5.7746 8.0603 5.89498 9.25647 5.57441L8.86817 4.12554C8.01522 4.35413 6.50739 4.27363 5.41266 3.83422C4.86508 3.61443 4.54219 3.35264 4.40704 3.11788C4.30873 2.94712 4.24749 2.6895 4.51569 2.22497L3.21665 1.47497Z" fill="#0855CB"/>
            </svg>

            <span class="ml-3">ดูการ์ดเชิญ</span>
          </div>
        </button>
      </div>
    </div>

    <div class="rounded-t-3xl p-5" style="height: 150px; background-color: #e7f1f9;">
      <div class="text-center">
        <p>ท่านสะดวกเข้าร่วมพิธีมงคลสมรสนี้หรือไม่?</p>

        <div class="flex items-center mt-8" style="font-family: Anuphan_medium; ">
          <button 
            class="h-12 w-full mr-2 px-5 text-wedding-blue transition-colors duration-150 bg-white border border-gray rounded-full focus:shadow-outline"
            @click="userNotAttend"
          >
            <!-- @click="handleAttend(false)" -->
            ไม่สะดวกเข้าร่วม
          </button>

          <button 
            class="h-12 w-full px-5  text-x text-white transition-colors duration-150 bg-wedding-blue rounded-full focus:shadow-outline hover:bg-wedding-blue"
            @click="handleAttend(true)"
          >
            เข้าร่วมงาน
          </button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <ModelImageCard
      :isShow="isModalImageCard"
      :imageUrl="frontImageCard"
      @cancel="isModalImageCard = false"
    />

    <ModalNotAttend
      :isShow="isModalNotAttend"
      @cancel="isModalNotAttend = false"
      @confirm="handleAttend"
    />
  </div>
</template>

<script>
import CardDetailInfo  from '../../components/CardDetailEventInfo.vue'
import ModelImageCard  from '../../components/Modal/ModaImageCard.vue'
import ModalNotAttend from '../../components/Modal/ModalNotAttend.vue'
import store from '../../store/index'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import 'viewerjs/dist/viewer.css'
import VueViewer, { api as viewerApi } from 'v-viewer'

export default {
  props: {
    submitNext: {
      type: Function
    }
  },
  components: {
    CardDetailInfo,
    ModelImageCard,
    ModalNotAttend,
  },
  setup (props) {
    const router = useRouter()

    let eventInfo = computed(() => store.state.signupForm.eventInfo)
    const brideName = computed(() => store.state.signupForm.brideName)
    const groomName = computed(() => store.state.signupForm.groomName)
    const frontImageCard = computed(() => store.state.signupForm.frontImageCard)
    const backImageCard = computed(() => store.state.signupForm.backImageCard)

    let isModalNotAttend = ref(false)
    let isModalImageCard = ref(false)

    const userNotAttend = ()  => {
      isModalNotAttend.value = true
    }

    const showImageCard = ()  => {
      isModalImageCard.value = true
    }

    const handleAttend = (val) => {
      if(val == false) {
        store.dispatch('guest/updateState', { key: 'attend', value: false })
        router.push({ path: '/not-attend' })
        return
      }

      props.submitNext()
      store.dispatch('guest/updateState', { key: 'attend', value: val })
    }

    const showViewer = () => {
      const tmpList = []
      tmpList.push(frontImageCard.value)
      tmpList.push(backImageCard.value)

      const $viewer = viewerApi({
        options: {
          title: false,
          rotatable: false,
          movable: true,
          scalable: false,
          toolbar: false
        },
        images: tmpList,
      })
    }

    return {
      eventInfo,
      brideName,
      groomName,
      frontImageCard,
      userNotAttend,
      showImageCard,
      isModalNotAttend,
      isModalImageCard,
      handleAttend,
      showViewer
    }
  }
}
</script>

<style>

</style>